import * as React from 'react';
import { Box, Tooltip } from '@material-ui/core';
import { useStyles } from '../../../custom-forms';
import { CaseCalculationPart } from '../../../interfaces/Case';
import { useTranslate } from '../../../hooks/useTranslate';
import { useVariantsEnabled } from '../context/CalculationFlagsContext';
import { offerVariants, queriedAlternatives } from '../utils/calculation.utils';

export interface AlternativeCalculationPartStatusProps {
  part: CaseCalculationPart;
}

const AlternativeCalculationPartStatus: React.FC<AlternativeCalculationPartStatusProps> = ({
  part
}) => {
  const c = useStyles();
  const t = useTranslate();
  const variantsEnabled = useVariantsEnabled();
  const { text, tooltip } = (() => {
    if (!part.hasBeenInterogated) {
      return { text: t('ALT_CALC_STATUS_NOT_QUERIED', 'fără interogare'), tooltip: '' };
    }
    const total = queriedAlternatives(part).length;
    if (!total) {
      return { text: t('ALT_CALC_STATUS_NO_RESULTS', 'fără rezultate'), tooltip: '' };
    }
    const selectedCount = offerVariants(part).length;
    const suffix = variantsEnabled
      ? selectedCount === 1
        ? t('ALT_CALC_STATUS_SELECTED_ONE', 'variantă selectată')
        : t('ALT_CALC_STATUS_SELECTED', 'variante selectate')
      : selectedCount === 1
      ? t('ALT_CALC_STATUS_SELECTED_SELECTIONS_ONE', 'selecție')
      : t('ALT_CALC_STATUS_SELECTED_SELECTIONS', 'selecții');
    return { text: `${selectedCount}/${total}`, tooltip: suffix };
  })();

  return (
    <Tooltip title={tooltip}>
      <Box component="span" className={`${c.badge} ${c.badgeOutline}`} style={{ justifySelf: 'start' }}>
        {text}
      </Box>
    </Tooltip>
  );
};

export default AlternativeCalculationPartStatus;
